<template>
  <div id="body">
    <img src="http://yd.top917.cn/date/images/ph_01.jpg">
    <img src="http://yd.top917.cn/date/images/ph_02.jpg">
    <img src="http://yd.top917.cn/date/images/ph_03.jpg">
    <div class="date">
      <img src="http://yd.top917.cn/date/images/ph_04.jpg">
      <!-- 滑动 s -->
      <div class="back wenzi"
      @touchstart.prevent="touchStart" @touchmove.prevent="touchMove"
      @touchend="touchEnd" ref="back">
        <div class="back-l " ref="left">
          <div>上周共有<span class="sz">{{ sguafen.sum || 0}}</span>人开奖瓜分10万</div>
          <div class="benzhou">本周您已销售<span class="xs">{{ myguafen.order_sum ||0 }}</span>单</div>
          <div class="paiming">你目前排名{{ mypaiming.pai || 0}}名</div>
          <div class="shuoming">活动无需报名，订单支付完成后后台自动计入</div>
          <div>（每周二22:00开奖）</div>
        </div>
        <div class="back-r " ref="right">
          <ul class="ph_topul">
            <li>用户名</li>
            <li>销售量</li>
            <li>排名</li>
            <div style="clear: both;"></div>
          </ul>
          <!-- <div>排行榜</div> -->  
			 
			 <ul class="ph_cent shang">
          <router-link 
          :to="{ path:item.id}"
          v-for="(item, index) in top10List"
            :key="index"
          >
				 <li>
					 <div>{{ item.real_name }}</div>
					 <div>{{ item.order_sum }}</div>
					 <div>{{ index + 1 }}</div>
					 <dd style="clear: both;"></dd>
				 </li>
         </router-link>
				 <div style="clear: both;"></div>
			</ul>	 
			 
        </div>
      </div>
    <!-- 滑动 e -->
    </div>


    <div id="sub" style="height: 0.6rem;">
      <div> 
        <router-link :to="'/'">
        <img src="http://yd.top917.cn/date/images/ph_05_01.jpg" />
        </router-link>
      </div>
      <div  v-if="weidui.is_dj == 1"><!-- 无可兑奖按钮 -->
        <img src="http://yd.top917.cn/date/images/ph_05_03.jpg">
      </div>
      
		  <div  @click="confirm" v-else> <!-- 可兑奖按钮 -->
        <img src="http://yd.top917.cn/date/images/ph_05_02.jpg" />
      </div>
	  
      <b style="clear: both;"></b>
    </div>
    <div class="doce">
      <img class='doce_spr' :src="myimg.img" />
      <img src="http://yd.top917.cn/date/images/ph_06.jpg">
    </div>
    <img src="http://yd.top917.cn/date/images/ph_07.jpg">
    <img src="http://yd.top917.cn/date/images/ph_08.jpg">
    <img src="http://yd.top917.cn/date/images/ph_09.jpg">
    <div style="position:relative;">
      <router-link :to="{ path: '/activity/bonus' }"><div class="xianqing" ></div></router-link>
      <img style="margin-top: -0.1rem;" src="http://yd.top917.cn/date/images/ph_10.jpg">
    </div>
  </div>
  
</template>
<style scoped>
  .ph_cent li div{
    float: left;
    width: 2rem;
  }
  .ph_cent{
    width: 6rem;
    margin: auto;
  }
  .ph_topul li{
    float: left;
    width: 2rem;
    font-weight: bold;
  }
  .ph_topul{
    width: 6rem;
    margin: auto;
  }

  .xianqing{
    position: absolute;
    left: 1.5rem;
    height: 1rem;
    width: 4.3rem;
  }
  .doce{
    position:relative;
  }
  .doce_spr{
    position: absolute;
    width: 2rem;
    left: 3rem;
    top: 0.4rem;
  }
  #sub div{
    width: 50%;
    float: left;
  }
  img{
    width: 100%;
    display: block;
  }
  .date{
    position:relative;
    overflow: hidden;
  }
  .wenzi{
    width: 7.5rem;
    position: absolute;
    top: 2rem;
    text-align: center;
    margin: auto;
  }
  .sz{
    color: red;
  }
  .benzhou{
    font-weight: bold;
    font-size: 0.5rem;
    margin: 0.1rem auto;
  }
  .xs{
    color: red;
  }
  .paiming{
    font-weight: bold;
    color: red;
    font-size: 0.35rem;
    margin-bottom: 0.3rem;
  }
  .shuoming{
    color: #999;
  }
.shang{
  height: 2.65rem;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: scroll;
}


.back{
    width: 100%;
    white-space: nowrap;
    
}
  
.back-l{
  position: relative;
  vertical-align: top;
  display: inline-block;
  width: 100%;
  height: 100%;
}
  
.back-r{
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 100%;
  
}



</style>

<script>
import { getMyguafen, getSguafen, getMyimg, getHuodongTop10, getMyWeiduijiang, getMyduijiang } from "@api/user";
export default {
  name: "Poster",
  components: {},
  props: {},
  data: function() {
    return {
      myguafen: {},
      mypaiming: {},
      sguafen: {},
      myimg:{},
	  top10List: [],
	  weidui:{},
      currentPlay: 'red',
      percent: 0,
    };
  },
  created() {
    this.touch = {}
  },
  mounted: function() {
	this.Guafen();
	this.Sguafen();
	this.Myimg();
	this.HuodongTop10();
	this.MyWeiduijiang();
  },
  methods: {
    Guafen:function(){
      let that = this;
      getMyguafen().then(res=>{
        that.myguafen = res.data.user;
        that.mypaiming = res.data;
      })
    },
    Sguafen:function(){
      let that = this;
      getSguafen().then(res=>{
        that.sguafen = res.data;
      })
    },
    Myimg:function(){
      let that = this;
      getMyimg().then(res=>{
        that.myimg = res.data;
      })
    },
	HuodongTop10:function(){
		let that = this;
	  getHuodongTop10().then(
	  res=>{
	    that.top10List  = res.data;
		console.log(res.data);
	  })
	  .catch(function(err) {
	    that.$dialog.message(err.msg);
	  });
	},
	MyWeiduijiang:function(){
		let that = this;
	  getMyWeiduijiang().then(
	  res=>{
		  that.weidui = res.data.data;
	  })
	},
	confirm(){
		getMyduijiang().then(res => {
			this.$dialog.success(res.msg);
			this.$router.go(-1);
		})
		.catch(res => {
		  this.$dialog.error(res.msg);
		});
	},

    touchStart(e) {
      const touch = e.touches[0]
      this.touch.startX = touch.pageX
      this.touch.startY = touch.pageY
    },
    touchMove(e) {
      console.log("move");
      const touch = e.touches[0]
      const deltaX = touch.pageX - this.touch.startX
      const deltaY = touch.pageY - this.touch.startY
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return
      }
      const left = this.currentPlay == 'red' ?  0 : -window.innerWidth
      var offsetWidth = Math.min(0, Math.max(-window.innerWidth,left+deltaX))
      this.percent = Math.abs(offsetWidth/window.innerWidth)
      this.$refs.back.style["transform"] = `translate3d(${offsetWidth}px,0,0)`
      this.$refs.back.style["transitionDuration"] = 10
 
 
 
    },
    touchEnd() {
      console.log("end");
      console.log(this.percent);
      let offsetWidth
      let percent
      if(this.currentPlay === 'red'){
        if(this.percent > 0.1) {
          this.currentPlay = 'yellow'
          offsetWidth = -window.innerWidth
        } else {
          offsetWidth = 0
        }
      } else {
        if(this.percent < 0.9) {
          this.currentPlay = 'red'
          offsetWidth = 0
        } else {
          offsetWidth = -window.innerWidth
        }
      }
      this.$refs.back.style["transform"]  = `translate3d(${offsetWidth}px,0,0)`
      this.$refs.back.style["transitionDuration"] = 10
    }


  }
};
</script>
